






















































































































































import {Component, Mixins} from "vue-property-decorator";
import {BasicMixin} from "@/mixins/AdminMixin";
import CardHeader from "@/components/CardHeader.vue"
import {State} from "vuex-class";
import {VideoCategoryInterface, VideoInterface} from "@/models/video";
import * as firebase from "firebase";


@Component({
    components:{
        CardHeader
    }
})
export default  class VideoAdminPractica extends Mixins(BasicMixin){

    @State(state => state.video.videos) videos: VideoInterface[];
    @State(state => state.video.videoCategories) categories: VideoCategoryInterface[];

    public headers = [
        {
            text: 'Titulo',
            align: 'left',
            sortable: true,
            value: 'title',
        },
        {
            text: 'Catgoria',
            align: 'left',
            sortable: true,
            value: 'category',
        },
        {
            text: 'Video',
            align: 'center',
            sortable: true,
            value: 'file',
        },
        {
            text: 'Externo',
            align: 'left',
            sortable: true,
            value: 'online',
        },

        { text: 'Opciones', value: 'actions' },
    ];

    public formImage: any = null;
    public formImageUrlPreview: any = null;
    public uploadValue = 0;


    public video: VideoInterface = {
        category: {
            name:'',
            id: ''
        },
        online: false,
        url: '',
        title: '',
        file:{
            path: '',
            size: 0,
            type: '',
            name:''
        }
    };

    public category: VideoCategoryInterface = {
        id: '',
        name:''
    };


    uploadFile(){
        const storageRef= firebase.storage().ref(`videos/${new Date().getTime()}_${this.formImage.name}`).put(this.formImage);
        storageRef.on(`state_changed`,snapshot=>{
                this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
            }, error=>{alert(error.message)},
            ()=>{this.uploadValue=100;
                storageRef.snapshot.ref.getDownloadURL().then((url)=>{
                    this.video.file.path = url;
                    this.video.file.type = this.formImage.type;
                    this.video.file.size = this.formImage.size;
                    this.video.file.name = this.formImage.name;
                });
            }
        );

    }

    previewImage(event: any) {
        this.formImage = event;
        this.formImageUrlPreview = URL.createObjectURL(event);
    }


    formSubmit(){
        if (this.edit){
            this.$store.dispatch('editCollect', {id: this.idModel, data: this.video, collection: 'videos'});
            this.text = 'Se ha editado la video';
            this.dialog = false;
            this.snackbar = true;
        } else {
            this.addId();
            this.$store.dispatch('createdVideo', this.video);
            this.text = 'Se ha creado el video';
            this.dialog = false;
            this.snackbar = true;
        }
    }

    openModal(edit: boolean, item: VideoInterface | any){
        this.edit = edit;
        this.dialog = true;
        this.formImage = null;
        this.formImageUrlPreview = null;
        this.uploadValue = 0;
        if (edit) {
            this.idModel = item.id;
            this.video = {
                title: item.title,
                file: item.file,
                category: item.category,
                url: item.url,
                online: item.online
            }
        } else {
            this.video = {
                title: '',
                category: {
                    name:'',
                    id: ''
                },
                online: true,
                url: '',
                file: {
                    type: '',
                    size: 0,
                    path: '',
                    name: ''
                }
            }

        }
    }

    deleteItem(item: VideoInterface){
        this.$store.dispatch('deleteCollect', {id:item.id, collection:'videos'})
    }

    changeOnline() {
        this.formImage = null;
        this.formImageUrlPreview = null;
        this.uploadValue = 0;
        this.video.file = {
            path: '',
            size: 0,
            type: '',
            name: ''
        };
        this.video.url = '';
    }
    changeCategory(category: VideoCategoryInterface){
        this.category.name = category.name;
        this.category.id = category.id;
    }
    addId() {
        this.video.category = {
            name: '',
            id: '',
        };
        this.video.category.name = this.category.name;
        this.video.category.id = this.category.id;
    }
}
